/* Private label buying block: price, Essential-only sample packaging, Buy Sample, bulk order panel. */
(function () {
  var box = document.getElementById('bt-buy');
  if (!box) return;
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  form.insertBefore(box, form.firstChild);

  var TIERS = [[1, 24, 1], [25, 49, .6], [50, 99, .5], [100, 499, .43], [500, 0, .35]];
  var variants = JSON.parse(box.querySelector('[data-bt-variants]').textContent);
  var select = form.querySelector('select[name="id"]');
  var qtyEl = box.querySelector('[data-bt-qty]');
  var tiersEl = box.querySelector('[data-bt-tiers]');
  var retailEl = box.querySelector('[data-bt-retail]');
  var panel = box.querySelector('.bt-bulk');
  var addWrap = form.querySelector('.product-form__quantity-submit');
  if (addWrap) { box.querySelector('[data-bt-add]').appendChild(addWrap); }

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function current() {
    var id = select ? +select.value : 0;
    return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
  }
  var sampleVariant = current;
  function variantOf(r) {
    return r && variants.filter(function (v) { return v.option1 === r.value; })[0];
  }
  function tierOf(q) { for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i][0] && (!TIERS[i][1] || q <= TIERS[i][1])) return i; return 0; }

  function prices() {
    var v = current(), q = Math.max(1, parseInt(qtyEl.value, 10) || 1), on = tierOf(q);
    var unit = Math.round(v.price * TIERS[on][2]);
    var sv = sampleVariant() || v;
    box.querySelector('[data-bt-reg]').textContent = money(sv.price);
    box.querySelector('[data-bt-low]').textContent = money(Math.round(sv.price * .35));
    var hideFirst = premiumChosen();
    tiersEl.innerHTML = TIERS.map(function (t, i) {
      if (hideFirst && i === 0) return '';
      return '<div class="bt-buy__row' + (i === on ? ' is-on' : '') + '" role="row"><span role="cell">' + (t[1] ? t[0] + ' to ' + t[1] : t[0] + ' or more') + ' units</span><span role="cell">' + money(Math.round(v.price * t[2])) + '/unit</span></div>';
    }).join('');
    box.querySelector('[data-bt-total]').textContent = q + (q === 1 ? ' unit' : ' units') + ' at ' + money(unit) + ' each: ' + money(unit * q);
    var retail = (parseFloat(retailEl.value) || 0) * 100;
    box.querySelector('[data-bt-profit]').textContent = 'Your profit: ' + money(retail - unit) + ' per unit, ' + money((retail - unit) * q) + ' on this order, before shipping and your other costs.';
    var label = addWrap && addWrap.querySelector('button[name="add"] span');
    if (label) label.textContent = 'Add ' + q + (q === 1 ? ' unit' : ' units') + ' to cart';
  }

  /* Dropdowns in place of the packaging pills; they drive the theme's own choices,
     so the preview and the selected variant keep working. Samples list Essential only;
     the bulk panel lists every level. */
  var pack = box.querySelector('[data-bt-pack]');
  var samplePack = box.querySelector('[data-bt-sample-pack]');
  var radios = form.querySelectorAll('input[data-index="option1"]');
  var groups = {};
  function isEssential(r) { return !/\+\$\d+/.test(r.value); }
  function styleOf(r) { var at = r.value.indexOf(': '); return at > -1 ? r.value.slice(at + 2) : r.value; }
  Array.prototype.forEach.call(radios, function (r, i) {
    var at = r.value.indexOf(': ');
    var level = at > -1 ? r.value.slice(0, at) : 'Packaging';
    var name = level.replace(/\s*\+.*$/, '');
    var m = level.match(/\+\$(\d+)/);
    var title = m ? name + ' (+$' + m[1] + ' per unit before bulk discount)' : name + ' (included)';
    if (!groups[title]) { groups[title] = document.createElement('optgroup'); groups[title].label = title; pack.appendChild(groups[title]); }
    var o = document.createElement('option');
    o.value = i; o.textContent = styleOf(r); o.selected = r.checked;
    groups[title].appendChild(o);
    if (isEssential(r)) {
      var s = document.createElement('option');
      s.value = i; s.textContent = styleOf(r);
      samplePack.appendChild(s);
    }
  });
  if (radios[+pack.value] && isEssential(radios[+pack.value])) samplePack.value = pack.value;
  sampleVariant = function () { return variantOf(radios[+samplePack.value]); };
  function premiumChosen() { var r = radios[+pack.value]; return r && !isEssential(r); }
  /* Anything under 25 units is Essential only; Premium and Luxe start at 25. */
  function guardQty() {
    var p = premiumChosen();
    qtyEl.min = p ? 25 : 1;
    if (p && (parseInt(qtyEl.value, 10) || 1) < 25) qtyEl.value = 25;
    box.querySelector('[data-bt-pack-note]').textContent = 'Orders under 25 units come in Essential packaging.' + (p ? ' Premium and Luxe start at 25 units.' : '');
  }
  pack.addEventListener('change', function () {
    var r = radios[+pack.value];
    r.click();
    if (isEssential(r)) samplePack.value = pack.value;
    guardQty();
    prices();
  });
  samplePack.addEventListener('change', function () {
    pack.value = samplePack.value;
    radios[+samplePack.value].click();
    guardQty();
    prices();
  });

  function submit(qty) {
    if (qty) qtyEl.value = qty;
    HTMLFormElement.prototype.submit.call(form);
  }
  box.querySelector('[data-bt-sample]').addEventListener('click', function () {
    var v = sampleVariant();
    if (v && select) select.value = v.id;
    submit(1);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"]');
    if (b && b.form === form) { e.preventDefault(); e.stopImmediatePropagation(); guardQty(); submit(); }
  }, true);
  qtyEl.addEventListener('change', function () { guardQty(); prices(); });
  panel.addEventListener('input', prices);
  form.addEventListener('change', function () { setTimeout(prices, 0); });
  guardQty();
  prices();
})();
